import classNames from "classnames";
import { stausClass } from ".";

interface TextAreaProps {
  children?: React.ReactNode;
  size?: "default" | "small";
  status?: "success" | "warning" | "error" | "pink" | "done" | "bg" | "default";
  className?: string;
  disabled?: boolean;
  onChange?: any;
  placeholder?: any;
}
function TextArea({
  children,
  className,
  disabled,
  onChange,
  status = "default",
  placeholder,
  ...otherProps
}: TextAreaProps) {
  const classes = classNames(
    "border p-2 rounded-xl text-sm focus:outline-none border-gray-200-mmpz focus:border-gray-200-mmpz hover:border-black-mmpz hover:text-black-mmpz",
    stausClass[status],
    {
      "border-gray-100-mmpz text-gray-100-mmpz placeholder:text-gray-100-mmpz":
        disabled,
    },
    className
  );
  return (
    <textarea
      className={classes}
      disabled={disabled}
      onChange={onChange}
      cols={30}
      rows={4}
      placeholder={placeholder}
      {...otherProps}
    >
      {children}
    </textarea>
  );
}

export default TextArea;
